import * as Constants from 'Containers/StartWebinar/constants';
import { setLocalStorage } from 'Utils/localStorage';

export function setWebinarLocaleStorageDetails(webinarKey, mode) {
  setLocalStorage(Constants.MODE_FOR_STARTING_WEBINAR, mode);
  setLocalStorage(webinarKey, webinarKey);
}
